import { namespaces } from 'virtual:locale-metadata';
export { mapping as LocaleMapping } from 'virtual:locale-metadata';
export { A as AT, S as SkipTranslate, a as autoTranslate } from '../shared/vite-auto-translate-plugin.fe8dfaf2.mjs';
import 'react/jsx-runtime';

const Namespaces = namespaces;

export { Namespaces };
